<template>
  <EntriesTable
    :attributes="storedAttributes"
    :has-min-width="hasMinWidth"
    :headers="storedHeaders"
    :is-hoverable="isHoverable"
    :list="storedList"
    :translated-headers="storedTranslatedHeaders"
    :truncated="storedTruncated"
  />
</template>

<script setup lang="ts">
import type { TableEntry, DetailedEntriesJSON } from '@app/types'

import { onBeforeUnmount, onMounted, ref } from 'vue'

import EntriesTable from './entries-table.vue'

interface Props {
  attributes?: string[]
  hasMinWidth?: boolean
  headers?: string[]
  isHoverable?: boolean
  list?: TableEntry[]
  translatedHeaders?: string[]
  truncated?: string
  updateEvent?:
    | 'interactive-report-communication:detailed-entries:updated'
    | 'interactive-report-communication:adjustment-entries:updated'
    | ''
}

const props = withDefaults(defineProps<Props>(), {
  attributes: () => [],
  headers: () => [],
  list: () => [],
  translatedHeaders: () => [],
  truncated: '',
  updateEvent: '',
})

const storedAttributes = ref<string[]>(props.attributes)
const storedHeaders = ref<string[]>(props.headers)
const storedList = ref<TableEntry[]>(props.list)
const storedTranslatedHeaders = ref<string[]>(props.translatedHeaders)
const storedTruncated = ref<string>(props.truncated)

onMounted(() => {
  if (props.updateEvent) {
    window.eventHub.$on(props.updateEvent, handleUpdate)
  }
})

onBeforeUnmount(() => {
  if (props.updateEvent) {
    window.eventHub.$off(props.updateEvent, handleUpdate)
  }
})

function handleUpdate(data: DetailedEntriesJSON) {
  storedAttributes.value = data.attributes
  storedHeaders.value = data.headers
  storedList.value = data.entries
  storedTranslatedHeaders.value = data.translated_headers
  storedTruncated.value = data.truncated || ''
}
</script>
